
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  --sic-accordion--default--button-border-color:var(--sic-accent-color);
  --sic-accordion--default--button-border-width:1px;
  --sic-accordion--default--button-background:transparent;
  --sic-accordion--default--button-background--hover:var(
  --color-primary-default
);
  --sic-accordion--default--button-font-size:var(--body-02-font-size);
  --sic-accordion--default--button-line-height:var(--body-02-line-height);
  --sic-accordion--default--button-text-color:var(--sic-heading-color);
  --sic-accordion--default--button-text-color--hover:var(--color-neutral-white);
  --sic-accordion--default--button-margin:0;
  --sic-accordion--default--button-padding:var(--spacing-04);
  --sic-accordion--default--icon-color:var(--sic-accent-color);
  --sic-accordion--default--icon-color--hover:var(--color-neutral-white);
  --sic-accordion--default--content-text-color:var(--sic-text-color);
  --sic-accordion--default--content-font-size:var(--body-01-font-size);
  --sic-accordion--default--content-padding:var(--spacing-01) var(--spacing-04) var(--spacing-04);
  --sic-accordion--default--spacing:var(--spacing-08);
  --sic-accordion--minimal--button-font-size:var(--body-01-font-size);
  --sic-accordion--minimal--button-padding:var(--spacing-02) var(--spacing-04);
}
.accordion-panel{
  display:flex;
  flex-direction:column;
}
[hidden]{
  display:none !important;
}
.accordion-button{
  border:none;
  border-color:var(--sic-accordion--default--button-border-color);
  border-color:var(
    --sic-accordion--button-border-color,
    var(--sic-accordion--default--button-border-color)
  );
  border-style:solid;
  border-width:0;
  border-bottom-width:var(--sic-accordion--default--button-border-width);
  border-bottom-width:var(
    --sic-accordion--button-border-width,
    var(--sic-accordion--default--button-border-width)
  );
  display:flex;
  width:100%;
  align-items:center;
  justify-content:space-between;
  color:var(--sic-accordion--default--button-text-color);
  color:var(
    --sic-accordion--button-text-color,
    var(--sic-accordion--default--button-text-color)
  );
  background-color:var(--sic-accordion--default--button-background);
  background-color:var(
    --sic-accordion--button-background,
    var(--sic-accordion--default--button-background)
  );
  margin:var(--sic-accordion--default--button-margin);
  margin:var(
    --sic-accordion--button-margin,
    var(--sic-accordion--default--button-margin)
  );
  padding:var(--sic-accordion--default--button-padding);
  padding:var(
    --sic-accordion--button-padding,
    var(--sic-accordion--default--button-padding)
  );
  position:relative;
  font-size:var(--sic-accordion--default--button-font-size);
  font-size:var(
    --sic-accordion--button-font-size,
    var(--sic-accordion--default--button-font-size)
  );
  font-weight:var(--fw-bold);
}
@media (prefers-reduced-motion: no-preference){
.accordion-button{
    transition:all var(--duration-slowly) ease-in-out
}
  }
.accordion-button:hover,
  .accordion-button:focus-visible{
    cursor:pointer;
    color:var(--sic-accordion--default--button-text-color--hover);
    color:var(
      --sic-accordion--button-text-color--hover,
      var(--sic-accordion--default--button-text-color--hover)
    );
    background-color:var(--sic-accordion--default--button-background--hover);
    background-color:var(
      --sic-accordion--button-background--hover,
      var(--sic-accordion--default--button-background--hover)
    );
  }
.accordion-button:hover .accordion-icon, .accordion-button:focus-visible .accordion-icon{
      color:var(--sic-accordion--default--icon-color--hover);
      color:var(
        --sic-accordion--icon-color--hover,
        var(--sic-accordion--default--icon-color--hover)
      );
    }
.accordion-button.active{
    border-bottom-color:transparent;
  }
.accordion-button.minimal{
    font-size:var(--sic-accordion--minimal--button-font-size);
    font-weight:normal;
    padding:var(--sic-accordion--minimal--button-padding);
  }
.accordion-button.minimal .accordion-label{
      font-weight:normal;
    }
hr{
  border:none;
  margin:0;
}
.accordion-icon{
  color:var(--sic-accordion--default--icon-color);
  color:var(
    --sic-accordion--icon-color,
    var(--sic-accordion--default--icon-color)
  );
  display:flex;
  align-items:center;
  width:18px;
  height:22px;
}
@media (prefers-reduced-motion: no-preference){
.accordion-icon{
    transition:all var(--duration-slowly) ease-in-out
}
  }
.accordion-label{
  text-align:left;
  font-family:var(--ff-body);
  font-size:var(--sic-accordion--default--button-font-size);
  font-size:var(
    --sic-accordion--button-font-size,
    var(--sic-accordion--default--button-font-size)
  );
  line-height:var(--sic-accordion--default--button-line-height);
  line-height:var(
    --sic-accordion--button-line-height,
    var(--sic-accordion--default--button-line-height)
  );
  font-weight:var(--fw-semibold);
}
.accordion-content{
  --sic-body-text--font-size:var(
    --sic-accordion--content-font-size,
    var(--sic-accordion--default--content-font-size)
  );

  border-color:var(--sic-accordion--default--button-border-color);

  border-color:var(
    --sic-accordion--button-border-color,
    var(--sic-accordion--default--button-border-color)
  );
  border-style:solid;
  border-width:0;
  border-bottom-width:var(--sic-accordion--default--button-border-width);
  border-bottom-width:var(
    --sic-accordion--button-border-width,
    var(--sic-accordion--default--button-border-width)
  );
  padding:var(--sic-accordion--default--content-padding);
  padding:var(
    --sic-accordion--content-padding,
    var(--sic-accordion--default--content-padding)
  );
  color:var(--sic-accordion--default--content-text-color);
  color:var(
    --sic-accordion--content-text-color,
    var(--sic-accordion--default--content-text-color)
  );
  font-size:var(--sic-accordion--default--content-font-size);
  font-size:var(
    --sic-accordion--content-font-size,
    var(--sic-accordion--default--content-font-size)
  );
  font-weight:var(--fw-normal);
  line-height:var(--sic-accordion--default--content-line-height);
  line-height:var(
    --sic-accordion--content-line-height,
    var(--sic-accordion--default--content-line-height)
  );
}
.accordion-content p{
    font-size:var(--sic-accordion--default--content-font-size);
    font-size:var(
      --sic-accordion--content-font-size,
      var(--sic-accordion--default--content-font-size)
    );
    margin:0;
  }
.accordion-content button.sic-cta.btt-button{
    margin-top:1rem;
  }
.accordion-content button.sic-cta.btt-button .last-word::after{
      transform:rotate(-90deg);
      transition:none;
    }
.btt-button{
  background:none;
  color:inherit;
  border:none;
  padding:0;
  font:inherit;
  cursor:pointer;
  outline:inherit;
}
`;